import { render, staticRenderFns } from "./TelEnrollModal.vue?vue&type=template&id=39974be9&scoped=true"
import script from "./TelEnrollModal.vue?vue&type=script&lang=js"
export * from "./TelEnrollModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39974be9",
  null
  
)

export default component.exports